import { FormikProvider, useFormik } from "formik";
import React from "react";
import { initialReportCategoriesValues } from "shared/constants";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { Page } from "shared/ui";
import { useTranslation } from "react-i18next";
import { noop } from "shared/helpers";
import { useModal } from "shared/hooks";
import { addOrUpdateReportCategoriesSchema } from "./report.schema";
import ReportCategoriesTable from "./ui/ReportCategoriesTable";
import AddReportCategoriesModal from "./ui/AddReportCategoriesModal";
import EditReportCategoriesModal from "./ui/EditReportCategoriesModal";

const ReportCategories = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isOpenAddModal, showAddModal, hideAddModal] = useModal();
  const [isOpenEditModal, showEditModal, hideEditModal] = useModal();

  const addOrUpdateReportCategoriesFormik = useFormik({
    initialValues: {
      ...initialReportCategoriesValues,
    },
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true,
    validationSchema: addOrUpdateReportCategoriesSchema,
    onSubmit: noop,
  });

  const handleShowAddModal = () => {
    showAddModal();
    addOrUpdateReportCategoriesFormik.validateForm();
  };

  const themeColor = JSON.parse(
    localStorage.getItem("color-theme") || '"#002F5F"'
  );

  return (
    <FormikProvider value={addOrUpdateReportCategoriesFormik}>
      <Page
        title="Report Categories"
        buttonTitle={t("Add Report Category")!}
        onClick={handleShowAddModal}
      >
        <div className="flex gap-2">
          <Button
            onClick={() => navigate("/recipient-list")}
            type="primary"
            style={{ backgroundColor: themeColor }}
          >
            Report Scheduling
          </Button>

          <Button
            onClick={() => navigate("/template-config")}
            type="primary"
            style={{ backgroundColor: themeColor }}
          >
            Report Configuration
          </Button>
        </div>
        <ReportCategoriesTable showEditModal={showEditModal} />

        <AddReportCategoriesModal
          isOpenNewReportModal={isOpenAddModal}
          closeAddReportModal={hideAddModal}
        />

        <EditReportCategoriesModal
          isOpen={isOpenEditModal}
          onClose={hideEditModal}
        />
      </Page>
      ;
    </FormikProvider>
  );
};

export { ReportCategories };
